import React, { useState } from 'react';
import Valg from '../../Shared/Scripts/Models/Valg';

interface VelgAntallArComponentProps {
    id: string | null,
    tittel: JSX.Element | null,
    forklaring: JSX.Element | null,
    ledetekst: JSX.Element | null,
    startAntallAr: number,
    onChange: any,
    obsmelding: JSX.Element | null,
}

export function VelgAntallArComponentVisning (props: VelgAntallArComponentProps): JSX.Element {

    const [antallAr, setAntallAr] = useState(props.startAntallAr);

    let obsTekst: JSX.Element | null = null;
    if(antallAr > 8) {
        obsTekst = <div>{props.obsmelding}</div>;
    } else {
        obsTekst = null;
    }

    function klikkMinusHandler(e: React.SyntheticEvent<HTMLButtonElement>) : void{
        if(antallAr > 1) {
            let valgtAntallAr: Valg<number> = { id: "", displayValue: "", value: antallAr - 1}
            setAntallAr(antallAr - 1);
            props.onChange(valgtAntallAr);
        }
    }

    function klikkPlussHandler(e: React.SyntheticEvent<HTMLButtonElement>) : void{
        if(antallAr < 9) {
            let valgtAntallAr: Valg<number> = { id: "", displayValue: "", value: antallAr + 1}
            setAntallAr(antallAr + 1);
            props.onChange(valgtAntallAr);
        }
    }

    function setAntallArState(e: React.KeyboardEvent<HTMLInputElement>): void {

        if(e.key === 'Backspace') {
            setAntallAr(0);
            props.onChange(undefined);
        }

        if(
            e.key === "1" || 
            e.key === "2" || 
            e.key === "3" || 
            e.key === "4" || 
            e.key === "5" || 
            e.key === "6" || 
            e.key === "7" || 
            e.key === "8" || 
            e.key === "9") {
                let typedAntallAr: number = parseInt(e.key);
                setAntallAr(typedAntallAr);

                let valgtAntallAr: Valg<number> = { id: "", displayValue: "", value: typedAntallAr}
                props.onChange(valgtAntallAr);
        }   
    }

    return (
        <div className="c-veileder__panel c-veileder__panel--input-white">
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content c-veileder__content--header">
                    <h3 className="c-veileder__tittel">{props.tittel}</h3>
                </div>
                <div className="c-veileder__content c-veileder__content--header c-veileder__content--indented">
                </div>
            </div>
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content c-veileder__content--textarea">
                    <div className="c-veileder__content--with-space">{props.forklaring}</div>
                    {obsTekst}
                </div>
                <div className="c-veileder__content c-veileder__content--inputarea c-veileder__content--indented">
                    <div className="c-veileder__inputomrade">
                        <div className="c-select-options__ledetekst" id={props.id + '-ledetekst'}>{props.ledetekst}</div>
                        <div className="c-text-input">
                        <div className="c-number-input c-number-input--minmax">
                                <button onClick={klikkMinusHandler} className="c-number-input__button c-number-input__button--sub">-</button>
                                <input
                                    aria-labelledby={props.id + '-ledetekst'}
                                    className="c-number-input__input c-number-input__input--minmax"
                                    min="0"
                                    max="9"
                                    type="number"
                                    value={antallAr}
                                    onChange={() : void => {}}
                                    onKeyUp={setAntallArState}
                                />
                                <button onClick={klikkPlussHandler} className="c-number-input__button c-number-input__button--add">+</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    ) 
}